import { Store } from '@/store/store.class'
import { PLANS, Plans, Plan } from '@/api/tripply/models/Plan'
import { Toast } from '@/api/models/Toast'

type RequestCount = {
  success?: number;
  error?: number;
}

interface DevState extends Object {
  requests: {
    route: RequestCount;
    cloud: {
      read: RequestCount;
      write: RequestCount;
    };
  };
}

class GlobalStore extends Store<DevState> {
  constructor() {
    super({
      name: 'global',
      cached: true,
      state: {
        requests: {
          route: {},
          cloud: {
            read: {},
            write: {}
          }
        }
      }
    })
  }

}
export const devStore = new GlobalStore()